export default "__VITE_ASSET__CgfFSBMO__"